<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md12>
				<v-layout row wrap>
					<v-flex xs12>
						<ValidationProvider
							name="name"
							rules="required"
							v-slot="{ errors, valid }"
						>
							<v-text-field
								v-model="item.name"
								:label="$t('Name')"
								prepend-icon="mdi-account"
								:error-messages="errors"
								:append-icon="valid ? 'mdi-check' : null"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 md12>
				<span v-for="(groups, index) in modules" :key="index">
					<div v-for="(permissions, g) in groups" :key="g">
						<div
							style="
								background-color: #f0f0f0;
								padding: 5px;
								margin-bottom: 10px;
							"
						>
							<strong class="text-uppercase">{{ $t(g) }}</strong>
							<v-sheet
								class="d-flex align-content-center align-center flex-wrap"
							>
								<div class="flex-1" style="width: 25%">
									<v-btn
										text
										x-small
										color="black"
										class="ml-2 mr-2"
										@click="selectAll(permissions)"
									>
										{{ $t("Select All") }}
									</v-btn>
									<v-btn
										text
										x-small
										color="red"
										@click="deselectAll(permissions)"
									>
										{{ $t("Deselect All") }}
									</v-btn>
								</div>
								<v-checkbox
									v-for="(permission, p) in permissions"
									:key="p"
									v-model="item.permission_names"
									:label="$t(permission.name)"
									:value="permission.name"
									density="compact"
									class="pa-0 ma-0 text-caption flex-1"
									hide-details
									single-line
									style="width: 25%"
								></v-checkbox>
							</v-sheet>
						</div>
					</div>
				</span>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
export default {
	props: ["value", "modules"],
	computed: {
		item: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},

	methods: {
		selectAll(permissions) {
			for (const permission of permissions) {
				if (!this.item.permission_names.includes(permission.name)) {
					this.item.permission_names.push(permission.name);
				}
			}
		},

		deselectAll(permissions) {
			for (const permission of permissions) {
				if (this.item.permission_names.includes(permission.name)) {
					this.item.permission_names.splice(
						this.item.permission_names.indexOf(permission.name),
						1
					);
				}
			}
		},
	},
};
</script>